var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconOffline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80px",
    height: "80px",
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Assets",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/Offline"
  }, /*#__PURE__*/React.createElement("g", {
    id: "iconOffline"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.2912113,23.6248854 C79.2912113,26.0456871 77.3275133,28.0141902 74.9019065,28.0141902 C73.5784002,28.0141902 72.4089046,27.4173926 71.6050919,26.4933038 L71.4655213,26.6328744 C62.9035123,19.2307508 51.7521523,14.7452201 39.5471127,14.7452201 C27.3850729,14.7452201 16.266856,19.20192 7.71495016,26.5558691 C6.91121147,27.4991784 5.72722652,28.1103914 4.38930481,28.1103914 C1.96357476,28.1103914 2.27373675e-13,26.1466935 2.27373675e-13,23.7210866 C2.27373675e-13,22.2002002 0.77487093,20.8622785 1.94915936,20.0778096 C12.0754242,11.3184205 25.2626824,6 39.701493,6 C54.0922524,6 67.2312128,11.279733 77.342939,19.9866353 C78.5220819,20.7711288 79.2920984,22.1091491 79.2920984,23.6251072 L79.2912113,23.6248854 Z",
    id: "Path",
    fill: "#DAD9E0",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8716177,32.6104854 C21.6865294,27.1671314 30.3059535,23.8896606 39.7055343,23.8896606 C49.0520121,23.8896606 57.628683,27.1286903 64.4285632,32.5190646 C65.7472643,33.2746781 66.6424977,34.6800195 66.6424977,36.3115472 C66.6424977,38.7372773 64.6787997,40.700852 62.257998,40.700852 C60.9296866,40.700852 59.7504575,40.0944318 58.9467681,39.1607451 L58.9178917,39.1896227 C53.6189381,35.0409442 46.9628423,32.5431371 39.7096778,32.5431371 C32.4181954,32.5431371 25.7279708,35.0650931 20.4152179,39.2522126 L20.3863403,39.223335 C19.5826016,40.1762793 18.3938115,40.7970779 17.0462795,40.7970779 C14.6205495,40.7970779 12.6569555,38.8333799 12.6569555,36.4077731 C12.6521622,34.7714403 13.5521588,33.3660003 14.8709093,32.6104854 L14.8716177,32.6104854 Z",
    id: "Path",
    fill: "#C2C0CC",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9748032,46.5626223 L27.0191928,45.5182326 C28.4582687,44.0791567 30.7876497,44.0791567 32.2267256,45.5182326 L39.7250752,53.0165822 L47.2234247,45.5182326 C48.6625006,44.0791567 50.9918816,44.0791567 52.4309575,45.5182326 L53.4753472,46.5626223 C54.9144231,48.0016982 54.9144231,50.3310792 53.4753472,51.7701551 L45.9769976,59.2685046 L53.1144693,66.4059763 C54.5535452,67.8450522 54.5535452,70.1744332 53.1144693,71.6135091 L52.0748971,72.6578988 C50.6358212,74.0969747 48.3064402,74.0969747 46.8673643,72.6578988 L39.7298926,65.5204271 L32.592421,72.6578988 C31.153345,74.0969747 28.8239641,74.0969747 27.3848881,72.6578988 L26.3404985,71.6135091 C24.9014225,70.1744332 24.9014225,67.8450522 26.3404985,66.4059763 L33.4779701,59.2685046 L25.9796206,51.7701551 C24.5405447,50.3310792 24.5405447,47.9968931 25.9748081,46.5626223 L25.9748032,46.5626223 Z",
    id: "Path",
    fill: "#AAA7B8",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 80,
    height: 80
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOffline);
export default __webpack_public_path__ + "static/media/iconOffline.5ba84b68.svg";
export { ForwardRef as ReactComponent };